import { useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import { IndicesRecord } from '@opensearch-project/opensearch/api/_types/cat.indices'
import { Indices_GetMapping_ResponseBody } from '@opensearch-project/opensearch/api/indices/getMapping'

import { indexSchema } from '../data/schema'
import { IndexFormData } from '../data/types'

export const useCreateAndEditIndexModal = (args?: Args) => {
  const index = args?.index
  const indexName = index?.index ?? ''
  const mappings = args?.mappings

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
    setValue,
  } = useForm<IndexFormData>({
    defaultValues: {
      index: '',
      body: {
        properties: mappings
          ? JSON.stringify(mappings?.[indexName]?.mappings?.properties, null, 2)
          : '',
      },
    },
    mode: 'onChange',
    resolver: yupResolver(indexSchema),
  })

  useEffect(() => {
    setValue('index', index?.index ?? '')
    setValue(
      'body.properties',
      JSON.stringify(mappings?.[indexName]?.mappings?.properties, null, 2),
    )
  }, [indexName, mappings])

  return {
    handleSubmit,
    errors,
    register,
    reset,
  }
}

type Args = { index?: IndicesRecord; mappings?: Indices_GetMapping_ResponseBody }
